import React from 'react';

type Props = {
  width?: number;
  height?: number;
  fill?: string;
  children: React.ReactNode;
  x?: number;
  y?: number;
};

const VectorIcon = ({
  children,
  width = 24,
  height = 24,
  fill = 'none',
  x,
  y,
}: Props): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill={fill}
      xmlns="https://www.w3.org/2000/svg"
      x={x}
      y={y}
    >
      {children}
    </svg>
  );
};

export default VectorIcon;
